import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { IAreaSearchResultDto } from 'src/models/search/area-search-result.model';
import { AreasStore } from 'src/stores/area-builder.store';
import { Area } from 'src/models/area-builder/area.model';
import { AreaType } from 'src/models/area-builder/area-type.enum';
import { createAreaFromSearchResult, getParentAreaKey } from 'src/app/area-builder/area-builder.utils';

@Component({
    selector: 'area-search-item',
    templateUrl: './area-search-item.component.html',
    styleUrl: './area-search-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class AreaSearchItemComponent {
    area: InputSignal<IAreaSearchResultDto> = input.required();
    areaType = AreaType;
    readonly areasStore = inject(AreasStore);
    shiftSelect = output<IAreaSearchResultDto>();

    isSelected = computed(() =>
        this.areasStore
            .selectedAreas()
            .some(
                (x: Area) =>
                    x.areaId === this.area().areaId &&
                    x.areaType === this.area().areaTypeId
            )
    );

    addArea(event: any) {
        if (event.shiftKey && this.areasStore.getPreviousSelectedArea() != null) {
            this.shiftSelect.emit(this.area());
        }
        const parentKey = getParentAreaKey(this.area().municipalityNumber, AreaType.Municipality);
        this.areasStore.addSelectedArea(
            createAreaFromSearchResult(this.area()),
            parentKey
        );
    }
    removeArea(event: any) {
        if (event.shiftKey && this.areasStore.getPreviousSelectedArea() != null) {
            this.shiftSelect.emit(this.area());
        }
        const parentKey = getParentAreaKey(this.area().municipalityNumber, AreaType.Municipality);
        this.areasStore.removeSelectedArea(
            createAreaFromSearchResult(this.area()),
            parentKey
        );
    }
}
